import React from 'react';
import { ImageProps } from './image.props';
import { default as NextImage } from 'next/image';

const Image = ({ className, src, alt, width, height, title, priority, itemProp, sizes, fill = true, id, referrerPolicy, ...rest }: ImageProps) => {
  if (!src) {
    return null;
  }

  return (
    <NextImage
      id={id}
      itemProp={itemProp}
      sizes={sizes}
      fill={fill}
      priority={priority}
      title={title}
      width={width}
      height={height}
      alt={alt}
      src={src}
      className={className}
      referrerPolicy={referrerPolicy}
      {...rest}
    />
  );
};

export default Image;
